import { render, staticRenderFns } from "./KefuIframe.vue?vue&type=template&id=21752d76&scoped=true"
import script from "./KefuIframe.vue?vue&type=script&lang=js"
export * from "./KefuIframe.vue?vue&type=script&lang=js"
import style0 from "./KefuIframe.vue?vue&type=style&index=0&id=21752d76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21752d76",
  null
  
)

export default component.exports